import React, { useCallback, useState } from "react";
import { 
  Layout, 
  Typography, 
  Switch, 
  Button, 
  Drawer, 
  Menu, 
  Space, 
  Divider 
} from "antd";
import { 
  MenuOutlined, 
  InboxOutlined, 
  AppstoreOutlined, 
  LogoutOutlined 
} from "@ant-design/icons";
import { useAuth0 } from "../../react-auth0-spa";
import { Link as RouterLink } from "react-router-dom";
import { useAppContext } from "../../context";

const { Header: AntHeader } = Layout;
const { Text, Title } = Typography;
const { Item: MenuItem } = Menu;

function Header() {
  const { logout } = useAuth0();
  const { isProd, toggleEnv } = useAppContext();

  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  const handleChangeEnv = useCallback(() => {
    toggleEnv();
  }, [toggleEnv]);

  const HeaderMenu = () => (
    <AntHeader style={{ backgroundColor: '#3D5864', padding: '0 16px' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src="https://cdn.onoranzefunebricloud.com/logos/singolo_white.png"
          width="61"
          height="40"
          alt="logo"
        />
        <Title level={4} style={{ color: '#fff', margin: '0 0 0 16px', flexGrow: 1 }}>
          OFC Mission Control
        </Title>
        
        <Space>
          <RouterLink to="/">
            <Button type="text" style={{ color: '#fff' }}>Apps</Button>
          </RouterLink>
          <Divider type="vertical" style={{ backgroundColor: '#fff' }} />
          
          <RouterLink to="/ci">
            <Button type="text" style={{ color: '#fff' }}>Pipelines</Button>
          </RouterLink>
          <Divider type="vertical" style={{ backgroundColor: '#fff' }} />
          
          <RouterLink to="/create-backup">
            <Button type="text" style={{ color: '#fff' }}>Create Backup</Button>
          </RouterLink>
          <Divider type="vertical" style={{ backgroundColor: '#fff' }} />
          
          <RouterLink to="/db/backup/restore">
            <Button type="text" style={{ color: '#fff' }}>Restore Backup</Button>
          </RouterLink>
        </Space>
        
        <div style={{ marginLeft: '16px', display: 'flex', alignItems: 'center' }}>
          <Text style={{ color: '#fff', marginRight: '8px' }}>PROD</Text>
          <Switch 
            checked={isProd} 
            onChange={handleChangeEnv}
            aria-label="environment toggle"
          />
        </div>
        
        <Button 
          type="text" 
          icon={<MenuOutlined style={{ color: '#fff', fontSize: '20px' }} />} 
          onClick={showDrawer}
          style={{ marginLeft: '16px' }}
        />
      </div>
    </AntHeader>
  );

  const SideMenu = () => (
    <Menu mode="vertical" style={{ width: '250px' }}>
      <MenuItem key="apps" icon={<AppstoreOutlined />} onClick={closeDrawer}>
        <RouterLink to="/">Apps</RouterLink>
      </MenuItem>
      <MenuItem key="ci-status" icon={<InboxOutlined />} onClick={closeDrawer}>
        <RouterLink to="/ci">Pipelines</RouterLink>
      </MenuItem>
      <Divider />
      <MenuItem key="logout" icon={<LogoutOutlined />} onClick={() => logout()}>
        Logout
      </MenuItem>
    </Menu>
  );

  return (
    <div>
      <HeaderMenu />
      <Drawer
        title="Menu"
        placement="right"
        onClose={closeDrawer}
        open={drawerVisible}
      >
        <SideMenu />
      </Drawer>
    </div>
  );
}

export default Header;
